var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / WarningOutlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.1567 12.6562C8.1567 12.88 8.24559 13.0946 8.40382 13.2529C8.56206 13.4111 8.77667 13.5 9.00045 13.5C9.22422 13.5 9.43883 13.4111 9.59707 13.2529C9.7553 13.0946 9.8442 12.88 9.8442 12.6562C9.8442 12.4325 9.7553 12.2179 9.59707 12.0596C9.43883 11.9014 9.22422 11.8125 9.00045 11.8125C8.77667 11.8125 8.56206 11.9014 8.40382 12.0596C8.24559 12.2179 8.1567 12.4325 8.1567 12.6562ZM8.43795 7.3125V10.5469C8.43795 10.6242 8.50123 10.6875 8.57857 10.6875H9.42232C9.49966 10.6875 9.56295 10.6242 9.56295 10.5469V7.3125C9.56295 7.23516 9.49966 7.17188 9.42232 7.17188H8.57857C8.50123 7.17188 8.43795 7.23516 8.43795 7.3125ZM16.7999 15.0469L9.48736 2.39062C9.37838 2.20254 9.19029 2.10938 9.00045 2.10938C8.8106 2.10938 8.62076 2.20254 8.51353 2.39062L1.20103 15.0469C0.98482 15.423 1.25552 15.8906 1.68795 15.8906H16.3129C16.7454 15.8906 17.0161 15.423 16.7999 15.0469ZM3.0274 14.5564L9.00045 4.21699L14.9735 14.5564H3.0274Z",
    fill: "#FF4D4F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/Caution.2ab426a3efd376507af4d037d9ac3bd2.svg";
export { ForwardRef as ReactComponent };